import api from './api'

export const progressService = {
  // Get all progress for current user
  getAll: async () => {
    const response = await api.get('/progress')
    return response.data
  },

  // Get progress by module
  getByModule: async (moduleId) => {
    const response = await api.get(`/progress?module_id=${moduleId}`)
    return response.data
  },

  // Get overall stats
  getStats: async () => {
    const response = await api.get('/progress/summary')
    return response.data
  },
}
